/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AutoTestStepBaseInputAsJSON } from './AutoTestStepBaseInputAsJSON';
import { CustomOutputExtra } from './CustomOutputExtra';
const CustomOutputInputAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(CustomOutputExtra, AutoTestStepBaseInputAsJSON);
export class CustomOutputInputAsJSON extends AutoTestStepBaseInputAsJSON {
    static decode(input) {
        return CustomOutputInputAsJSONParser.decode(input).map(res => new CustomOutputInputAsJSON(res));
    }
    static unsafeDecode(input) {
        return CustomOutputInputAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CustomOutputInputAsJSONParser.encode(data);
    }
    static schema() {
        return CustomOutputInputAsJSONParser.schema();
    }
}
